import { TypographyOptions } from "@mui/material/styles/createTypography";

import { fontSizes } from "./fontsizes";
export const typography: TypographyOptions = {
  fontFamily: "Inter, Arial, sans-serif",
  h1: {
    fontSize: fontSizes.display48,
  },
  h2: {
    fontSize: fontSizes.display40,
  },
  h3: {
    fontSize: fontSizes.heading28,
  },
  h4: {
    fontSize: fontSizes.heading24,
  },
  h5: {
    fontSize: fontSizes.heading20,
  },
  body1: {
    fontSize: fontSizes.bodymedium18,
  },
  body2: {
    fontSize: fontSizes.bodynormal16,
  },
  caption: {
    fontSize: fontSizes.bodysmall14,
  },
  subtitle1:{
    fontSize: fontSizes.bodysmall12,
  }
};
